// extracted by mini-css-extract-plugin
export var header = "Header-module--header--923a3";
export var subtitle = "Header-module--subtitle--c511a";
export var title = "Header-module--title--cfc45";